import { ISvgProps } from '@src/types';

const MeetingEndIcon = ({ ...props }: ISvgProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="34px" height="34px" viewBox="0 0 34 34" version="1.1" {...props}>
      <title>Group Copy</title>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-Copy" transform="translate(1, 1)">
          <rect
            id="Rectangle-Copy"
            stroke="#42444C"
            strokeWidth="0.31104"
            fill="#00ACFB"
            x="0"
            y="0"
            width="32"
            height="32"
            rx="9.24479961"
          />
          <g id="Shape" transform="translate(4, 4)" fill="#FFFFFF">
            <path
              d="M18.3,8.59 L19.21,7.69 C19.6021222,7.29787783 19.6021222,6.66212217 19.21,6.27 C18.8178778,5.87787783 18.1821222,5.87787783 17.79,6.27 L16.89,7.18 C14.0075726,4.95018109 9.98242738,4.95018109 7.1,7.18 L6.19,6.26 C5.7951164,5.86787785 5.15712219,5.87011643 4.76500002,6.26500002 C4.37287786,6.65988361 4.37511642,7.29787782 4.77,7.69 L5.69,8.6 C4.59301541,9.99754526 3.99779061,11.723345 3.99997353,13.5 C3.99102947,17.0034675 6.2627163,20.1051812 9.60559545,21.153763 C12.9484746,22.2023447 16.5847303,20.9538122 18.5783897,18.0728945 C20.5720491,15.1919767 20.4592307,11.3490011 18.3,8.59 L18.3,8.59 Z M12,19.5 C8.6862915,19.5 6,16.8137085 6,13.5 C6,10.1862915 8.6862915,7.5 12,7.5 C15.3137085,7.5 18,10.1862915 18,13.5 C18,15.0912989 17.367859,16.6174224 16.2426407,17.7426407 C15.1174224,18.867859 13.5912989,19.5 12,19.5 Z M10,4.5 L14,4.5 C14.5522847,4.5 15,4.05228475 15,3.5 C15,2.94771525 14.5522847,2.5 14,2.5 L10,2.5 C9.44771525,2.5 9,2.94771525 9,3.5 C9,4.05228475 9.44771525,4.5 10,4.5 Z M13,10.5 C13,9.94771525 12.5522847,9.5 12,9.5 C11.4477153,9.5 11,9.94771525 11,10.5 L11,12.39 C10.5364452,12.8046161 10.3768252,13.4622828 10.5987415,14.0432671 C10.8206577,14.6242514 11.3780759,15.008034 12,15.008034 C12.6219241,15.008034 13.1793423,14.6242514 13.4012585,14.0432671 C13.6231748,13.4622828 13.4635548,12.8046161 13,12.39 L13,10.5 Z"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default MeetingEndIcon;
